import type { ReactElement } from "react";
import { BarChart3, Film, Image, Users } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "../../../../shared/components/ui/tabs";
import type { ViewMode } from "../types";

interface ViewModeSelectorProps {
  readonly value: ViewMode;
  readonly onChange: (mode: ViewMode) => void;
}

/**
 * View mode selector for bulk editor
 * Switches between different column configurations optimized for specific tasks
 */
export function ViewModeSelector({ value, onChange }: Readonly<ViewModeSelectorProps>): ReactElement {
  return (
    <Tabs value={value} onValueChange={(val) => onChange(val as ViewMode)} className="w-full">
      <TabsList className="grid w-full grid-cols-5 bg-neutral-900/0 border border-neutral-800/0">
        <TabsTrigger
          value="basic"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:text-lumi-accent"
        >
          <Film className="h-4 w-4" />
          <span className="hidden sm:inline">Basic Info</span>
          <span className="sm:hidden">Basic</span>
        </TabsTrigger>

        <TabsTrigger
          value="cast"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:text-lumi-accent"
        >
          <Users className="h-4 w-4" />
          <span className="hidden sm:inline">Cast & Crew</span>
          <span className="sm:hidden">Cast</span>
        </TabsTrigger>

        <TabsTrigger
          value="visual"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:text-lumi-accent"
        >
          <Image className="h-4 w-4" />
          <span className="hidden sm:inline">Visual Assets</span>
          <span className="sm:hidden">Visual</span>
        </TabsTrigger>

        <TabsTrigger
          value="video"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:text-lumi-accent"
        >
          <Film className="h-4 w-4" />
          <span className="hidden sm:inline">Video Assets</span>
          <span className="sm:hidden">Video</span>
        </TabsTrigger>

        <TabsTrigger
          value="stats"
          className="flex items-center gap-2 data-[state=active]:bg-transparent data-[state=active]:text-lumi-accent"
        >
          <BarChart3 className="h-4 w-4" />
          <span className="hidden sm:inline">Quick Stats</span>
          <span className="sm:hidden">Stats</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
